module.exports = __webpack_public_path__ + "static/media/um.05615112.svg";